module.exports = __webpack_public_path__ + "static/media/role.88a37fa6.svg";